
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface TemplatePreviewProps {
  template: {
    id?: string;
    name: string;
    subject: string;
    previewText?: string;
    content: string;
  };
  onClose: () => void;
}

export const TemplatePreview: React.FC<TemplatePreviewProps> = ({ template, onClose }) => {
  // Function to process template variables for display (for demonstration)
  const processContent = (content: string) => {
    return content
      .replace(/{{subscriber_name}}/g, "John Doe")
      .replace(/{{unsubscribe_link}}/g, "#unsubscribe");
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <Card className="w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col">
        <CardHeader className="bg-slate-50 border-b border-slate-200 px-6 py-4 flex-row items-center justify-between space-y-0">
          <div>
            <CardTitle className="text-lg text-slate-800">Template Preview</CardTitle>
            <div className="flex items-center mt-1 gap-2">
              <span className="text-sm text-slate-500">{template.name}</span>
              <Badge variant="outline" className="text-xs">Preview</Badge>
            </div>
          </div>
          <Button variant="ghost" size="icon" onClick={onClose} className="h-8 w-8">
            <X className="h-4 w-4" />
          </Button>
        </CardHeader>
        <CardContent className="p-0 overflow-auto flex-1">
          <div className="p-6 space-y-4">
            <div className="space-y-2">
              <h3 className="text-sm font-medium text-slate-500">Subject Line:</h3>
              <p className="text-base p-2 bg-slate-50 border border-slate-200 rounded-md">
                {template.subject}
              </p>
            </div>
            
            {template.previewText && (
              <div className="space-y-2">
                <h3 className="text-sm font-medium text-slate-500">Preview Text:</h3>
                <p className="text-base p-2 bg-slate-50 border border-slate-200 rounded-md">
                  {template.previewText}
                </p>
              </div>
            )}
            
            <div className="space-y-2">
              <h3 className="text-sm font-medium text-slate-500">Email Content:</h3>
              <div className="border border-slate-200 rounded-md p-6 bg-white min-h-[300px]">
                <div
                  className="prose max-w-none"
                  dangerouslySetInnerHTML={{ __html: processContent(template.content) }}
                />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
